// src/services/DeleteUserService.js
import { 
  doc, 
  deleteDoc, 
  collection, 
  query, 
  where, 
  getDocs
} from 'firebase/firestore';
import { db } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Delete a user and all associated data
 * 
 * @param {string} userId - The ID of the user to delete
 * @returns {Promise<boolean>} - True if successful
 */
export const deleteUserAndData = async (userId) => {
  try {
    // 1. Delete user's listings
    const listingsQuery = query(
      collection(db, 'listings'),
      where('userId', '==', userId)
    );
    
    const listingsSnapshot = await getDocs(listingsQuery);
    const deleteListingsPromises = [];
    
    listingsSnapshot.forEach(doc => {
      deleteListingsPromises.push(deleteDoc(doc.ref));
    });
    
    // Wait for all listings to be deleted
    await Promise.all(deleteListingsPromises);
    
    // 2. Delete user's application (if any)
    try {
      await deleteDoc(doc(db, 'serviceProviderApplications', userId));
    } catch (error) {
      // Application might not exist, so we can ignore this error
      console.log("No application found for user or error deleting application:", error);
    }
    
    // 3. Delete user document
    await deleteDoc(doc(db, 'users', userId));
    // 4. Delete Firebase Auth account (requires admin via callable function)
    try {
      const functions = getFunctions();
      const deleteAuthUser = httpsCallable(functions, 'adminDeleteUserAuth');
      await deleteAuthUser({ userId });
    } catch (error) {
      console.error("Error deleting Firebase Auth user:", error);
      throw new Error("User data was removed, but deleting the sign-in account failed. Please try again or contact support.");
    }

    return true;
  } catch (error) {
    console.error("Error deleting user and associated data:", error);
    throw error;
  }
};
